<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemLogDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-log-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :ok-text="state.dialog.submitTxt" :cancel-button-props="{ style: { display: 'none' } }" @ok="closeDialog"
    @cancel="closeDialog" :closable="false" :maskClosable="false">
    <div class="form-content">
      <a-descriptions :column="2">
        <a-descriptions-item label="操作时间">{{ info.createTime || '' }}</a-descriptions-item>
        <a-descriptions-item label="人员ID">{{ info.createBy || '' }}</a-descriptions-item>
        <a-descriptions-item label="操作模块">{{ info.moduleName || '' }}</a-descriptions-item>
        <a-descriptions-item label="操作页面">{{ info.pageName || '' }}</a-descriptions-item>
        <a-descriptions-item label="操作类型">{{ info.opType || '' }}</a-descriptions-item>
        <a-descriptions-item label="请求地址">{{ info.pageUrl || '' }}</a-descriptions-item>
      </a-descriptions>
      <div class="log-json mt20">
        <div class="log-json-label">入参：</div>
        <pre class="log-json-pre">{{ transitionOut(info.input) || '' }}</pre>
      </div>
      <div class="log-json">
        <div class="log-json-label">出参：</div>
        <pre class="log-json-pre">{{ transitionOut(info.output) || '' }}</pre>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="systemLogDialog">
import { reactive, ref } from 'vue'

const state = reactive({
  dialog: {
    visible: false,
    title: '操作详情',
    submitTxt: '关闭',
    width: '750px'
  }
})

const info = ref<any>({})

const openDialog = (row: any) => {
  state.dialog.visible = true
  info.value = row
}

const transitionOut = (text: string) => {
  if (!text) return ''
  try {
    return JSON.stringify(JSON.parse(text), null, 2)
  } catch {
    return text
  }
}

const closeDialog = () => {
  state.dialog.visible = false
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 30px 36px;
}

.log-json {
  display: flex;
  margin-bottom: 20px;

  .log-json-label {
    width: 60px;
    color: #999;
    flex-shrink: 0;
  }

  .log-json-pre {
    flex: 1;
    border: solid 1px #d9d9d9;
    border-radius: 4px;
    padding: 10px;
    max-height: 240px;
    overflow: hidden;
    overflow-y: auto;
    background: #f5f5f5;
    margin: 0;
  }
}

.mt20 {
  margin-top: 20px;
}
</style>
